export function formatEventTime(startTime) {
  const eventDate = new Date(startTime);
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Europe/Berlin',
  };
  return eventDate.toLocaleDateString('de-DE', options);
}